<script lang="ts" setup>
useHead({
  link: [
    {
      rel: 'icon',
      type: 'image/svg',
      href: '/favicon.svg',
      media: '(prefers-color-scheme: light)',
    },
    {
      rel: 'icon',
      type: 'image/svg',
      href: '/favicon-light.svg',
      media: '(prefers-color-scheme: dark)',
    },
  ],
})
const locale = useI18n().locale
// console.log('locale', locale.value)
const localePath = useLocalePath()

const errorMessage = computed(() => {
  return locale.value === 'da' ? 'Side ikke fundet' : 'Page not found'
})
const buttonLabel = computed(() => {
  return locale.value === 'da' ? 'Ga til forside' : 'Go to homepage'
})

const handleError = () => clearError({ redirect: localePath('/') })

const globalDataEndpoints = ['footer', 'navigation', 'settings']
const { globalData, setGlobalData } = useVildmarkenState()
await callOnce(fetchGlobalData)

async function fetchGlobalData() {
  console.log('fetchGlobalData error page')
  try {
    const fetchers = {
      footer: () => useSanityQuery(getFooter, { language: locale.value }),
      navigation: () => useContent(getNavigation, { cacheKey: 'global-navigation' }),
      settings: () =>
        useSanityQuery(getSettings, { language: locale.value, cacheKey: 'global-settings' }),
    }

    const responses = await Promise.allSettled(
      globalDataEndpoints.map((endpoint) => fetchers[endpoint]()),
    )

    const data = responses.reduce(
      (acc, res, idx) => {
        if (res.status !== 'fulfilled') return acc
        const key = camelize(globalDataEndpoints[idx])
        acc[key] = res.value.data
        return acc
      },
      {} as Record<string, any>,
    )

    setGlobalData(data)
  } catch (error) {
    throw createError({
      statusCode: 500,
      statusMessage: 'Could not get global data',
    })
  }
}
</script>

<template>
  <div class="error-page relative">
    <CommonMogbilleCursor />

    <NuxtLayout class="relative h-full w-full">
      <div class="relative h-[100svh]">
        <div class="page relative flex h-full flex-col gap-10 pt-16 lg:gap-20">
          <ElementsPoopCollector />
          <div
            class="go-home absolute top-1/2 left-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-5"
          >
            <h1 class="font-display title relative z-2 text-lg lg:text-xl">
              {{ errorMessage }}
            </h1>
            <ElementsArrowButton class="mt-auto" @click="handleError">{{
              buttonLabel
            }}</ElementsArrowButton>
          </div>
          <!-- <pre><code>{{ error }}</code></pre> -->
        </div>
      </div>
      <SiteFooter class="!h-[calc(100vh+1px)]" />
    </NuxtLayout>
  </div>
</template>
